module.exports = __webpack_public_path__ + "static/img/credit_score.411f8531.png";